import { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/Text';

import ProLabel from './ProLabel';

export default function TabItem({
  children,
  isPro,
}: {
  children: ReactNode;
  isPro?: boolean;
}) {
  return (
    <div className="flex w-full justify-between">
      <Text className="p-1 text-left" variant="studio/body/medium/sm">
        {children}
      </Text>
      {isPro && <ProLabel />}
    </div>
  );
}
